const SYMBOLS = { EUR: "€", USD: "$", CHF: "CHF", AED: "AED", MAD: "MAD", GBP: "£" };

export function formatMoney(amount, currency = "EUR") {
  if (amount == null || isNaN(amount)) return "—";
  const abs = Math.abs(amount);
  let str;
  if (abs >= 1000000) str = (amount / 1000000).toFixed(2).replace(/\.00$/, "") + " M";
  else if (abs >= 1000) str = Math.round(amount / 1000) + " k";
  else str = String(amount);
  const sym = SYMBOLS[currency] || currency;
  return ["EUR", "USD", "GBP"].includes(currency) ? `${str} ${sym}` : `${str} ${sym}`;
}

export function formatFull(amount, currency = "EUR") {
  if (amount == null || isNaN(amount)) return "—";
  const sym = SYMBOLS[currency] || currency;
  return `${new Intl.NumberFormat("fr-FR").format(amount)} ${sym}`;
}
